module.exports = __webpack_public_path__ + "static/media/background.df93ab5a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/GettingStarted/background.jpg
 ** module id = 1365
 ** module chunks = 0
 **/